module.exports = __webpack_public_path__ + "static/media/map_and_terrain.193baa3c.jpg";